import React, {useContext} from "react";
import {ProjectContext} from "../../contexts/ProjectContext";
import {CompanyType} from "../../models/company";
import BidderScopesPage from "./builder/BidderScopeList";
import ScopeOverview from "./developer/ScopeOverview";
import {DeveloperScopeView} from "./developer/ScopePage";
import {BidderScopeView} from "./builder/ScopeView";

export function RootScopesListPage (){
    const projectContext = useContext(ProjectContext);
    if(projectContext?.role === CompanyType.builder){
        return <BidderScopesPage/>
    }
    else if (projectContext?.role === CompanyType.developer){
        // bid tab is the main view - the card list is at scope_cards
        return <ScopeOverview/>
    } else {
        return <></>
    }
}


export function RootScopeView (){
    const projectContext = useContext(ProjectContext);
    if(projectContext?.role === CompanyType.builder){
        return <BidderScopeView/>
    }
    else if (projectContext?.role === CompanyType.developer){
        return <DeveloperScopeView/>
    } else {
        return <></>
    }
}
